import { CIMSModule, CIMSPage, Permission } from '@cims-online/shared'
import { useProtectedMenuItem } from './useProtectedMenuItem'

export function useImportsExports() {
  return useProtectedMenuItem({
    module: CIMSModule.ImportsExports,
    pages: [
      {
        permission: [Permission.ImportCSV, Permission.ExportCSV],
        page: CIMSPage.CSV,
      },
      {
        permission: Permission.CreateReport,
        page: CIMSPage.PDFReports,
      },
      {
        permission: Permission.CreateBatchReportRequest,
        page: CIMSPage.BatchReports,
      },
      {
        permission: Permission.CreatePhotoExportRequest,
        page: CIMSPage.PhotoExports,
      },
      {
        permission: Permission.ViewPDFDesignLayer,
        page: CIMSPage.PDFDesignLayers,
      },
      {
        permission: Permission.ViewFilename,
        page: CIMSPage.Filenames,
      },
    ],
  })
}
